import { useNavigate } from 'react-router-dom';
import { Grid3x3, List, Calendar, Table, Plus } from 'lucide-react';
import { Button } from '@/components/common/Button';
import { PageHeader } from '@/components/common/PageHeader';

interface ViewHeaderProps {
  currentView: 'cards' | 'table' | 'board' | 'calendar';
  title: string;
  subtitle: string;
  onCreateClick?: () => void;
  showCreateButton?: boolean;
}

export default function CallViewHeader({ 
  currentView, 
  title, 
  subtitle,
  onCreateClick,
  showCreateButton = true
}: ViewHeaderProps) {
  const navigate = useNavigate();

  const views = [
    { id: 'cards', label: 'Cards', icon: Grid3x3, path: '/calls' },
    { id: 'table', label: 'Table', icon: Table, path: '/calls/table' },
    { id: 'board', label: 'Board', icon: List, path: '/calls/board' },
    { id: 'calendar', label: 'Calendar', icon: Calendar, path: '/calls/calendar' },
  ];

  return (
    <PageHeader
      title={title}
      description={subtitle}
      className="mb-6"
      actions={
        <>
          {/* View Switcher */}
          <div className="flex gap-1 bg-gray-100 rounded-lg p-1">
            {views.map((view) => {
              const Icon = view.icon;
              const isActive = currentView === view.id;

              return (
                <Button
                  key={view.id}
                  variant={isActive ? 'default' : 'ghost'}
                  size="sm"
                  onClick={() => navigate(view.path)}
                  className={`flex items-center gap-2 ${isActive ? '' : 'text-gray-600'}`}
                >
                  <Icon className="w-4 h-4" />
                  <span className="hidden md:inline">{view.label}</span>
                </Button>
              );
            })}
          </div>

          {/* Create Button */}
          {showCreateButton && onCreateClick && (
            <Button onClick={onCreateClick}>
              <Plus className="w-4 h-4 mr-2" />
              Schedule Call
            </Button>
          )}
        </>
      }
    />
  );
}
